import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import {
  STEP_STATUS_CONFIG,
  type OnboardingStepStatus,
} from '@/lib/onboarding/steps'

export function StepStatusBadge({ status }: { status: string }) {
  const config =
    STEP_STATUS_CONFIG[status as OnboardingStepStatus] ??
    STEP_STATUS_CONFIG.pending
  return (
    <Badge variant="outline" className={cn('border-transparent', config.className)}>
      {config.label}
    </Badge>
  )
}
